import { createGlobalState } from '@vueuse/core';
import { ref, nextTick } from 'vue';
import { useToasted } from '~/composables/useToasted';
import usersClient from '~/services/usersClient';
import { catchRequestError } from '~/utils/request';

export interface TeamUser {
    id: number;
    name: string;
    email: string;
    role: string;
    org_unit_count: number;
    group_count: number;
}

const defaultUser = (): TeamUser => ({
    id: 0,
    name: '',
    email: '',
    role: '',
    org_unit_count: 0,
    group_count: 0,
});

export const useTeamUserDetails = createGlobalState(() => {
    const toasted = useToasted();

    const user = ref<TeamUser>(defaultUser());
    const loading = ref(true);

    const mount = async (teamId: number, userId: number) => {
        await nextTick();

        try {
            loading.value = true;
            const response = await usersClient.getUser(teamId, userId);
            user.value = response.data;
            loading.value = false;
        } catch (e) {
            toasted?.error(catchRequestError(e));
            // loading is never set on false on error on detail screens
            // when the screen errors we show a toast and the spinner loads
            // forever this the way the user knows the screen crashed for good
        }
    };

    const unmount = () => {
        user.value = defaultUser();
        loading.value = false;
    };

    return {
        loading,
        user,
        mount,
        unmount,
    };
});
